<template>

    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mb-2"
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <br>
        <v-tabs background-color="brand onBrand--text" centered dark icons-and-text style="margin-top:-20px">
            <v-tabs-slider></v-tabs-slider>

            <v-tab @click="tab = 'parent-notice'">
                Notice
                <v-icon>mdi-file-star-outline</v-icon>
            </v-tab>

            <v-tab @click="tab = 'parent-album'">
                Album
                <v-icon>mdi-image-album</v-icon>
            </v-tab>

            <!-- <v-tab @click="tab = 'parent-calendar'">
                Calendar
                <v-icon>mdi-calendar</v-icon>
            </v-tab> -->
            <!-- <v-tab @click="tab = 'parent-calendar'">
                Academic Calendar
                <v-icon>mdi-calendar</v-icon>
            </v-tab> -->
        </v-tabs>
        <v-card>
            <v-card-text v-if="tab == 'parent-notice'">
                <parent-notice></parent-notice>
            </v-card-text>
            <v-card-text v-if="tab == 'parent-album'">
                <parent-album></parent-album>
            </v-card-text>
            <!-- <v-card-text v-if="tab == 'parent-calendar'">
                <parent-calendar></parent-calendar>
            </v-card-text> -->
            <v-card-text v-if="tab == 'parent-calendar'">
                <parent-calendar></parent-calendar>
            </v-card-text>
        </v-card>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Communication Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/3dHSngR2IHY?si=D6TilN4CbOfm6Zw0"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    import ParentNotice from './ParentNotice'
    import ParentAlbum from './ParentAlbum'
    // import ParentCalendar from './ParentCalendar'
    import ParentCalendar from '@/components/Academics/AcademicPlanner/Parent/ChildAcademicPlan'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        name: "ParentNotice",
        name: "ParentAlbum",
        components:{
            "parent-notice":ParentNotice,
            "parent-album":ParentAlbum,
            "parent-calendar": ParentCalendar,
            Breadcrumbs
        },
        data: () => ({
            snackbar_msg: "",
            snackbar: false,
            videoDialog:false,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            //
            tab: "parent-notice",
        }),
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            comm_type(type) {
                this.tab = type;
                this.$router.push({ name: type });
            },
        },
        mounted() {
            // this.$router.push({ name: this.tab });
            // axios
            //   .post("")
            //   .then(res => {})
            //   .catch(error => {})
            //   .finally(() => {});
        },
    };
</script>
